"use client"

import { useEffect, useState } from "react"
import { Link, useLocation } from "react-router-dom"
import axios from "axios"

const Menus = () => {
  const [categories, setCategories] = useState([])
  const [subCategories, setSubCategories] = useState({})
  const [activeCategory, setActiveCategory] = useState(null)
  const [showPopup, setShowPopup] = useState(false)
  const [formData, setFormData] = useState({
    name: "",
    mobile: "",
    email: "",
  })
  const [loading, setLoading] = useState(false)
  const [formErrors, setFormErrors] = useState({})
  const [submitStatus, setSubmitStatus] = useState(null)
  const location = useLocation()

  useEffect(() => {
    setActiveCategory(null)
  }, [location.pathname])

  useEffect(() => {
    const fetchCategories = async () => {
      try {
        // Fetch main categories with their IDs
        const mainResponse = await axios.get(
          "https://admin.lumetiq.in/api/get-main-categories.php"
        )
        const mainCategories = mainResponse.data.data

        // Fetch all subcategories
        const subResponse = await axios.get(
          "https://admin.lumetiq.in/api/categories/read.php"
        )
        const allSubCategories = subResponse.data.records

        // Create a mapping of main categories to their subcategories
        const categoryMapping = {}
        mainCategories.forEach(mainCat => {
          const subCats = allSubCategories.filter(subCat => 
            String(subCat.main_category_id) === String(mainCat.id)
          )
          categoryMapping[mainCat.name] = subCats
        })

        setCategories(mainCategories.map(cat => cat.name))
        setSubCategories(categoryMapping)
      } catch (error) {
        console.error("Error fetching categories:", error)
      }
    }

    fetchCategories()
  }, [])

  const validateForm = () => {
    const errors = {}
    let isValid = true

    if (!formData.name) {
      errors.name = "Name is required."
      isValid = false
    }
    if (!formData.mobile || !/^\d{10}$/.test(formData.mobile)) {
      errors.mobile = "Enter a valid 10-digit mobile number."
      isValid = false
    }
    if (!formData.email || !/^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(formData.email)) {
      errors.email = "Enter a valid email address."
      isValid = false
    }

    setFormErrors(errors)
    return isValid
  }

  const handleDownloadBrochure = async (e) => {
    e.preventDefault()
    if (validateForm()) {
      setLoading(true)
      setSubmitStatus(null)

      try {
        // Create form data
        const formDataToSend = new FormData()
        formDataToSend.append("name", formData.name)
        formDataToSend.append("mobile", formData.mobile)
        formDataToSend.append("email", formData.email)

        // Use the correct working endpoint
        const phpEndpoint = "https://palegoldenrod-panther-953114.hostingersite.com/sendEmail.php"

        console.log("Sending request to:", phpEndpoint)

        const response = await axios.post(phpEndpoint, formDataToSend, {
          headers: {
            "Content-Type": "multipart/form-data",
          },
        })

        console.log("Response:", response)

        if (response.status === 200) {
          setSubmitStatus({ type: "success", message: "Email sent successfully!" })

          // Download the brochure
          const brochureUrl = location.pathname === '/fire'
            ? "/assets/LUMETIQ FIRE DEFENCE-2020.pdf"
            : location.pathname === '/green'
            ? "/assets/LUMETIQ GREEN ENERGY-2020.pdf"
            : "/assets/LUMETIQ CATALOG-2020.pdf";
          const link = document.createElement("a")
          link.href = brochureUrl
          link.download = "Brochure.pdf"
          document.body.appendChild(link)
          link.click()
          document.body.removeChild(link)

          // Reset form
          setShowPopup(false)
          setFormData({ name: "", mobile: "", email: "" })
        } else {
          setSubmitStatus({ type: "error", message: "Failed to send email. Please try again." })
        }
      } catch (error) {
        console.error("Error details:", error)

        let errorMessage = "Network error occurred. Please check your connection and try again."

        if (error.response) {
          // The request was made and the server responded with a status code
          // that falls out of the range of 2xx
          console.error("Error response data:", error.response.data)
          console.error("Error response status:", error.response.status)

          if (error.response.status === 404) {
            errorMessage = "Email service not found. Please check the path to your PHP file."
          } else if (error.response.status === 403) {
            errorMessage = "Access to email service is forbidden. Please check server permissions."
          }
        } else if (error.request) {
          // The request was made but no response was received
          console.error("Error request:", error.request)
          errorMessage = "No response from server. Please try again later."
        }

        setSubmitStatus({ type: "error", message: errorMessage })
      } finally {
        setLoading(false)
      }
    }
  }

  const handleInputChange = (e) => {
    const { name, value } = e.target
    setFormData((prevData) => ({ ...prevData, [name]: value }))
    // Clear error for this field when user starts typing
    if (formErrors[name]) {
      setFormErrors((prev) => ({ ...prev, [name]: null }))
    }
  }

  return (
    <>
      <ul>
        <li>
          <Link className="h2" to="/home-3" onClick={() => setActiveCategory(null)}>Home</Link>
        </li>
        <li>
          <Link className="h2" to="/about" onClick={() => setActiveCategory(null)}>About us</Link>
        </li>
        <li className="has-dropdown" onMouseLeave={() => setActiveCategory(null)}>
          <Link className="h2" to="#" onClick={() => setActiveCategory(null)}>Products</Link>
          
          <ul className="submenu" onMouseLeave={() => setActiveCategory(null)}>
            {categories.map((category, index) => {
              const hasSubs = subCategories[category]?.length > 0;
              const targetLink = category.toLowerCase() === 'green energy'
                ? '/green'
                : category.toLowerCase() === 'fire safety'
                ? '/fire'
                : `/products/${category.toLowerCase()}`;

              return (
                <li
                  key={index}
                  className={activeCategory === category && hasSubs ? "has-dropdown active" : hasSubs ? "has-dropdown" : ""}
                  onMouseEnter={() => {
                    setActiveCategory(hasSubs ? category : null);
                  }}
                >
                  <Link to={targetLink} onClick={() => setActiveCategory(null)}>{category}</Link>
                  
                  {activeCategory === category && hasSubs && (
                    <ul className="submenu">
                      {subCategories[category].map((subCat, idx) => (
                        <li key={`sub-${idx}`}>
                          <Link to={`/products/${subCat.name.toLowerCase()}`} onClick={() => setActiveCategory(null)}>
                            {subCat.name}
                          </Link>
                        </li>
                      ))}
                    </ul>
                  )}
                </li>
              );
            })}
          </ul>
        </li>
        <li>
          <Link className="h2" to="/service" onClick={() => setActiveCategory(null)}>Service</Link>
        </li>
        <li>
          <Link className="h2" to="/contact" onClick={() => setActiveCategory(null)}>Contact</Link>
        </li>
        <li>
          <Link className="h2" to="#" onClick={() => { setActiveCategory(null); setShowPopup(true); }}>
            Download Brochure
          </Link>
        </li>
        <li>
          <Link className="h2" to="/faq" onClick={() => setActiveCategory(null)}>FAQ</Link>
        </li>
        <li>
          <Link className="h2" to="/career" onClick={() => setActiveCategory(null)}>Career</Link>
        </li>
      </ul>

      {/* Popup Form */}
      {showPopup && (
        <div id="popup-overlay">
          <div id="popup-content">
            <h2>Fill the Form to Download Brochure</h2>
            {submitStatus && <div className={`status-message ${submitStatus.type}`}>{submitStatus.message}</div>}
            <form onSubmit={handleDownloadBrochure}>
              <div className="form-group">
                <label htmlFor="name" style={{ color: "black", position: "relative", right: "195px" }}>
                  Name:
                </label>
                <input type="text" id="name" name="name" value={formData.name} onChange={handleInputChange} />
                {formErrors.name && <p className="error">{formErrors.name}</p>}
              </div>

              <div className="form-group">
                <label htmlFor="mobile" style={{ color: "black", position: "relative", right: "195px" }}>
                  Mobile:
                </label>
                <input type="text" id="mobile" name="mobile" value={formData.mobile} onChange={handleInputChange} />
                {formErrors.mobile && <p className="error">{formErrors.mobile}</p>}
              </div>

              <div className="form-group">
                <label htmlFor="email" style={{ color: "black", position: "relative", right: "195px" }}>
                  Email:
                </label>
                <input type="email" id="email" name="email" value={formData.email} onChange={handleInputChange} />
                {formErrors.email && <p className="error">{formErrors.email}</p>}
              </div>

              <div style={{ display: "flex", justifyContent: "space-between" }}>
                <button className="tp-btn-border" type="submit" disabled={loading}>
                  {loading ? "Sending..." : "Download"}
                </button>
                <button className="btn1" type="button" onClick={() => setShowPopup(false)}>
                  Cancel
                </button>
              </div>
            </form>
          </div>
        </div>
      )}

      {/* CSS Styles */}
      <style>
        {`
          #popup-overlay {
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background-color: rgba(0, 0, 0, 0.5);
  display: flex;
  justify-content: center;
  align-items: center;
  z-index: 9999;
}

#popup-content {
  background-color: #ffffff;
  padding: 30px;
  border-radius: 12px;
  box-shadow: 0 4px 20px rgba(0, 0, 0, 0.3);
  width: 100%;
  max-width: 500px;
  animation: fadeIn 0.3s ease-in-out;
}

#popup-content h2 {
  margin-bottom: 20px;
  text-align: center;
  color: #333;
}

.form-group {
  margin-bottom: 15px;
}

.form-group label {
  display: block;
  margin-bottom: 5px;
  font-weight: 600;
  color: #444;
}

.form-group input {
  width: 100%;
  padding: 10px;
  border: 1px solid #ccc;
  border-radius: 6px;
  outline: none;
  transition: border 0.3s ease;
}

.form-group input:focus {
  border-color: #0078ff;
}

.error {
  color: #ff3b3b;
  font-size: 12px;
  margin-top: 5px;
}

.status-message {
  padding: 10px;
  border-radius: 4px;
  margin-bottom: 15px;
  text-align: center;
}

.status-message.success {
  background-color: #d4edda;
  color: #155724;
  border: 1px solid #c3e6cb;
}

.status-message.error {
  background-color: #f8d7da;
  color: #721c24;
  border: 1px solid #f5c6cb;
}

#popup-buttons {
  display: flex;
  justify-content: space-between;
  margin-top: 15px;
}

#popup-buttons button {
  padding: 10px 20px;
  border: none;
  border-radius: 6px;
  cursor: pointer;
  background-color: #0078ff;
  color: #fff;
}

.btn1 {
	font-size: 12px;
	text-transform: uppercase;
	line-height: 22px;
	font-weight: 500;
	color: var(--tp-common-black);
	letter-spacing: 0.18em;
	padding: 20px 40px;
	border: 1px solid rgba(135, 135, 135, .25);
	display: inline-block;

	&:hover {
		background-color:red;
		color: var(--tp-common-white);

		& span svg:first-child,
		& span i:first-child {
			opacity: 1;
			transform: translateZ(0);
		}

		& span svg:last-child,
		& span i:last-child {
			opacity: 0;
			transform: translateX(30px) translateY(0);
		}
	}
}

#popup-buttons button:last-child {
  background-color: #ff3b3b;
}

@keyframes fadeIn {
  from {
    opacity: 0;
    transform: scale(0.9);
  }
  to {
    opacity: 1;
    transform: scale(1);
  }
}
        `}
      </style>
    </>
  )
}

export default Menus